import React from 'react'
// utils
import {LogoDom, randomCoding} from '@/utils'
// enum
import {AppType} from '@/enum'
// less
import './index.less'

interface IProps {
  title: string
  subTitle: string
  explain?: string
  extra?: React.JSX.Element[]
  appType?: AppType
  showIcon?: boolean
  coverText?: string
}

/**
 * 通用数据列表展示块
 * @constructor
 */
const ListItemBlockComponent = (props: IProps) => {
  return (
    <div key={randomCoding()} className={"list-item-block flex items-center w-full bg-gray-100"}
         style={{
           minHeight: "60px",
           borderRadius: 8,
           padding: 20,
           overflow: 'hidden',
           position: "relative"
         }}
    >
      {props.showIcon && <div className={"w-[45px] h-[45px]"}>
        {LogoDom(props.appType || AppType.HOSE, 45)}
      </div>}
      <div className={["flex-1", props.showIcon && 'pl-[12px]'].join(' ')}>
        <div className={"font-bold text-[16px]"}>{props.title}</div>
        {props.subTitle && <div className={"text-[16px] list-item-sub"}>{props.subTitle}</div>}
        {props.explain && <div className={"mt-[6px]"}>{props.explain}</div>}
      </div>
      <div className={"list-item-extra flex w-[350px] items-center justify-end space-x-[20px]"}>
        {props.extra}
      </div>
      {props.coverText && <div
          className={"absolute text-[12px] text-right bg-[#cbcbcb] z-10 right-0 top-0 pr-[8px] pl-[8px]"}>
        {props.coverText}
      </div>}
    </div>
  )
}

export default ListItemBlockComponent
